import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'achoo-color-picker',
  templateUrl: './achoo-color-picker.component.html',
  styleUrls: ['./achoo-color-picker.component.scss']
})
export class AchooColorPickerComponent implements OnInit {

  @Input() color;
  @Input() priority: number;
  @Input() defaultColor: string;

  @Output() changeColorEvent: EventEmitter<any> = new EventEmitter<any>();

  public originalColor: string;


  ngOnInit() {
    this.originalColor = this.color;
  }

  onSaveColor() {
    this.originalColor = this.color;
    this.changeColorEvent.emit({
      color: this.color,
      shouldClose: true
    });
  }

  onResetColor() {
    this.color = this.defaultColor || this.originalColor;
    this.changeColorEvent.emit({
      color: this.color,
      shouldClose: false
    });
  }

  onChangeColorInput(evt) {
    this.color = evt;
    this.changeColorEvent.emit({
      color: this.color,
      shouldClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-color-picker/achoo-color-picker.component.ts